import { BackgroundStyle, ForegroundStyle, BorderSize, BorderStyle } from '../../Style';
export var ButtonType;
(function (ButtonType) {
    ButtonType["Primary"] = "primary";
    ButtonType["High"] = "high";
    ButtonType["Mid"] = "mid";
    ButtonType["Low"] = "low";
    ButtonType["Secondary"] = "secondary";
    ButtonType["Buy"] = "buy";
    ButtonType["Sell"] = "sell";
    ButtonType["SellOutline"] = "sell_outline";
})(ButtonType || (ButtonType = {}));
export const ButtonTypeClass = {
    [ButtonType.Primary]: `${BackgroundStyle.Primary} ${ForegroundStyle.FilledElements} ${BorderSize.None}`,
    [ButtonType.High]: `${BackgroundStyle.High} ${ForegroundStyle.FilledElements} ${BorderSize.None}`,
    [ButtonType.Mid]: `${BackgroundStyle.Mid} ${ForegroundStyle.FilledElements} ${BorderSize.None}`,
    [ButtonType.Low]: `${BackgroundStyle.Low} ${ForegroundStyle.FilledElements} ${BorderSize.None}`,
    [ButtonType.Secondary]: `${BackgroundStyle.Secondary} ${BackgroundStyle.Outline} ${ForegroundStyle.OutlineElements} ${BorderSize.Solid1} ${BorderStyle.General}`,
    [ButtonType.SellOutline]: `${BackgroundStyle.Sell} ${BackgroundStyle.Outline} ${ForegroundStyle.OutlineElements} ${BorderSize.Solid1} ${BorderStyle.OutlineSell}`,
    [ButtonType.Buy]: `${BackgroundStyle.Buy} ${ForegroundStyle.FilledElements} ${BorderSize.None}`,
    [ButtonType.Sell]: `${BackgroundStyle.Sell} ${ForegroundStyle.FilledElements} ${BorderSize.None}`
};
